import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { AuthService } from '../share/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApproverGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {

    if (this.authService.isLoggedIn()) {
      return true;
    }

    // 🔹 Parse the URL
    const tree = this.router.parseUrl(state.url);

    return this.router.createUrlTree(
      ['/login'],
      {
        queryParams: {
          returnUrl: tree.root.children['primary']?.segments
            .map(s => s.path)
            .join('/'),

          //forward original query params (no nesting)
          ...tree.queryParams
        }
      }
    );
  }
}
